import { api } from "./api";
import { priceOf } from "@/config";

export const comboMembers = (combo, products) => [...new Set(combo.product_ids || [])].map((id) => ({
  id,
  product: products.find((product) => product.id === id),
  qty: Math.max(1, Math.floor(Number(combo.bundle_qty?.[id]) || 1)),
}));

export const comboItemIssue = ({ product, qty }, cart = []) => {
  if (!product) return "No longer available";
  if (product.is_live === false) return "Coming soon";
  if (!(product.stock > 0)) return "Sold out";
  const alreadyAdded = cart.find((item) => item.product.id === product.id)?.qty || 0;
  if (product.stock < qty + alreadyAdded) return "Not enough stock for this full set";
  return "";
};

export async function loadComboPreview(id) {
  // Refresh the offer and every member, rather than adding a stale or partial set.
  const [offers, products] = await Promise.all([api.get("/offers", { timeout: 15000 }), api.get("/products", { timeout: 15000 })]);
  const combo = offers.data.find((offer) => offer.id === id && offer.deal_type === "bundle");
  if (!combo) throw new Error("This combo offer is no longer available.");
  const members = comboMembers(combo, products.data);
  let quote = null;
  if (members.length >= 2 && members.every(({ product }) => product)) {
    const { data } = await api.post("/orders/quote", {
      items: members.map(({ product, qty }) => ({
        product_id: product.id, name: product.name, sku: product.sku || "", price: priceOf(product), qty,
      })),
    }, { timeout: 15000 });
    quote = data;
  }
  return { combo, members, quote };
}

// If products or pricing changed while the preview was open, require another review.
export const comboFingerprint = ({ combo, members, quote }) => JSON.stringify({
  title: combo.title,
  members: members.map(({ id, product, qty }) => ({
    id, qty, name: product?.name, sku: product?.sku, image: product?.image,
    size_options: product?.size_options,
    issue: comboItemIssue({ product, qty }),
  })),
  quote,
});